module.exports = __webpack_public_path__ + "static/watl-logo-9cc92b144d14bdc31f67815cdaf20e8b.png";